import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'

// スクロールして画面エリアに入ったら要素を表示する lazydisp
import LAZYDISP from '../plugins/lazydisp'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

// IEでのpictureタグ対応
import IE_SRCSET from '../plugins/polyfill-ie-srcset'

const [ w, d, l ] = [ window, document, location];

export default function INIT() {

  IE_SRCSET();

  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
    'loadHtml': new $.Deferred, // すべてのLoad Htmlが完了したらresolveする
  }

  window.load['loadHtml'].then(() => document.dispatchEvent( new CustomEvent('loadHtml') ) );



  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: ( l.pathname == '/service/' && query_string('article') == 2 ) ? '/asset/html/repaint-foot.html' : '/asset/html/footer.html',
      target: 'footer',
      method:'replaceWith',
      callback(){
        $('footer [data-plugin="getCopyright"]').getCopyright()
      }
    },
    {
      name: 'header',
      loadhtml: ( l.pathname == '/service/' && query_string('article') == 2 ) ? '/asset/html/repaint-head.html?ts=20220513' : '/asset/html/header.html',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .p-gnav').currentMenu({mode:1,default:999});
      }
    }
  ])

  
  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'sitemap':'<span>Sitemap</span><small>サイトマップ</small>',
    'privacy':'<span>Privacy Policy</span><small>プライバシーポリシー</small>',
    'profile':'<span>Profile</span><small>会社概要</small>'
  })

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    window.load['loadHtml'].then(() => {
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999})
    })
    // ページングテキスト
    $.pagingText({
      prev:'PREV',
      next:'NEXT',
      list:'LIST'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore() {
        $('.p-pagetop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-pagetop__wrap').removeClass('hidden');
      }
    });

    $.when( window.load['loadHtml'] ).then( () => {
      // lazydisp
      LAZYDISP('[data-lazydisp]') // lazydisp実行 使い方は`/less/component/lazydisp.less`を参照
    });
    
  });

}